module.exports = __webpack_public_path__ + "img/single-3.7eaf277b.png";